module.exports = __webpack_public_path__ + "img/revestimento.73442aaf.svg";